import {bindable, inject, LogManager, customElement} from 'aurelia-framework';
import * as _ from "lodash";
import {AirportChoiceLoader} from "./airport-choice-loader";

const logger = LogManager.getLogger('AirportChoiceElement');

@customElement('sio-airport-choice-input')
@inject(
    AirportChoiceLoader
)
export class AirportChoiceElement
{
    @bindable config;
    @bindable({defaultBindingMode: 2}) value;

    loading = true;

    constructor(
        choiceLoader
    ) {
        this.choiceLoader = choiceLoader;
    }

    async attached()
    {
        this.loading = true;
        this._choices = await this.choiceLoader.load();
        this.loading = false;
    }
}
